import snsAxiosClient from '../common/http/http-sns';
import formatString from '../utils/formatString';
import { get } from 'lodash';

function zipcodeToCity(environmentVariables, user, zipcode: string) {
  const options = {
    headers: {
      ...get(environmentVariables, 'ZIPCODE_LOOKUP_API_HEADERS_GET_V1'),
      Authorization: `Bearer ${get(user, 'authToken')}`,
    },
  };

  return snsAxiosClient(options).get(
    formatString(get(environmentVariables, 'ZIPCODE_TO_CITY_API', 'zipcode_to_city'), {
      zipcode,
    }),
  );
}

export default zipcodeToCity;
